export default __webpack_public_path__ + "static/media/facebook-f-brands (1).2705e57d.svg";